import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3d97dc72")

_pushScopeId("data-v-3d97dc72")
const _hoisted_1 = { class: "circular-border" }
const _hoisted_2 = {
  key: 1,
  class: "content"
}
const _hoisted_3 = { class: "availability-start" }
const _hoisted_4 = { class: "star-average" }
const _hoisted_5 = /*#__PURE__*/_createVNode("p", null, "Este estabelecimento ainda não recebeu avaliações.", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_header_with_balance = _resolveComponent("header-with-balance")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_RatingStars = _resolveComponent("RatingStars")
  const _component_ItemRatings = _resolveComponent("ItemRatings")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")
  const _component_ion_list = _resolveComponent("ion-list")
  const _component_ion_card_content = _resolveComponent("ion-card-content")
  const _component_ion_card = _resolveComponent("ion-card")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_content, null, {
        default: _withId(() => [
          _createVNode(_component_header_with_balance, {
            title: "Avaliações",
            "has-go-back": true
          }),
          _createVNode("div", _hoisted_1, [
            ($setup.loadingRef)
              ? (_openBlock(), _createBlock(_component_ion_spinner, { key: 0 }))
              : _createCommentVNode("", true),
            ($setup.ratingsRef?.length > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_2, [
                  _createVNode("section", null, [
                    _createVNode("div", _hoisted_3, [
                      _createVNode("h1", null, _toDisplayString($options.formatRating($setup.ratingRef)), 1),
                      _createVNode("div", _hoisted_4, [
                        _createVNode(_component_RatingStars, { rating: $setup.ratingRef }, null, 8, ["rating"])
                      ])
                    ])
                  ]),
                  _createVNode(_component_ion_list, null, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.ratingsRef, (rating) => {
                        return (_openBlock(), _createBlock(_component_ion_item, {
                          key: rating.id,
                          lines: "none",
                          class: "no-padding"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_ItemRatings, {
                              rating: rating,
                              logo: $setup.logo
                            }, null, 8, ["rating", "logo"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128)),
                      _createVNode(_component_ion_infinite_scroll, {
                        onIonInfinite: _cache[1] || (_cache[1] = ($event: any) => ($setup.getRatings($event)))
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_infinite_scroll_content, { "loading-spinner": "dots" })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : (!$setup.loadingRef)
                ? (_openBlock(), _createBlock(_component_ion_card, {
                    key: 2,
                    class: "no-ratings"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_card_content, null, {
                        default: _withId(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})